/**
 * The raw, *unvalidated* content source.
 *
 * GENERATED by `npm run sync:content` — do not edit by hand.
 *
 * These imports are the only place in the app that touches content files
 * directly, and everything they hand out is `unknown` on purpose: the bundler
 * will happily give us whatever JSON is on disk, and nothing may be trusted
 * until `validateCatalog` has run over it.
 */
import type { RawContent } from './validateCatalog.ts';

import subjects from '../../content/subjects.json' with { type: 'json' };
import modules from '../../content/modules.json' with { type: 'json' };

import englishConnectors from '../../content/lessons/english-connectors.json' with { type: 'json' };
import englishPhrasalVerbs from '../../content/lessons/english-phrasal-verbs.json' with { type: 'json' };
import englishPresentContinuous from '../../content/lessons/english-present-continuous.json' with { type: 'json' };
import englishPresentPerfect from '../../content/lessons/english-present-perfect.json' with { type: 'json' };
import englishPresentSimple from '../../content/lessons/english-present-simple.json' with { type: 'json' };
import englishWorkOffice from '../../content/lessons/english-work-office.json' with { type: 'json' };
import playwrightAssertions from '../../content/lessons/playwright-assertions.json' with { type: 'json' };
import playwrightAutoWaiting from '../../content/lessons/playwright-auto-waiting.json' with { type: 'json' };
import playwrightDebugging from '../../content/lessons/playwright-debugging.json' with { type: 'json' };
import playwrightLocatorStrategy from '../../content/lessons/playwright-locator-strategy.json' with { type: 'json' };
import playwrightNetworkMocking from '../../content/lessons/playwright-network-mocking.json' with { type: 'json' };
import playwrightTestIsolation from '../../content/lessons/playwright-test-isolation.json' with { type: 'json' };
import pythonConditions from '../../content/lessons/python-conditions.json' with { type: 'json' };
import pythonDictionaries from '../../content/lessons/python-dictionaries.json' with { type: 'json' };
import pythonFunctions from '../../content/lessons/python-functions.json' with { type: 'json' };
import pythonListsTuples from '../../content/lessons/python-lists-tuples.json' with { type: 'json' };
import pythonLoops from '../../content/lessons/python-loops.json' with { type: 'json' };
import pythonVariables from '../../content/lessons/python-variables.json' with { type: 'json' };
import typescriptFunctions from '../../content/lessons/typescript-functions.json' with { type: 'json' };
import typescriptGenerics from '../../content/lessons/typescript-generics.json' with { type: 'json' };
import typescriptInterfaces from '../../content/lessons/typescript-interfaces.json' with { type: 'json' };
import typescriptNarrowing from '../../content/lessons/typescript-narrowing.json' with { type: 'json' };
import typescriptTypes from '../../content/lessons/typescript-types.json' with { type: 'json' };
import typescriptUtilityTypes from '../../content/lessons/typescript-utility-types.json' with { type: 'json' };

import plCatalog from '../../content/pl/catalog.json' with { type: 'json' };
import plEnglishConnectors from '../../content/pl/lessons/english-connectors.json' with { type: 'json' };
import plEnglishPhrasalVerbs from '../../content/pl/lessons/english-phrasal-verbs.json' with { type: 'json' };
import plEnglishPresentContinuous from '../../content/pl/lessons/english-present-continuous.json' with { type: 'json' };
import plEnglishPresentPerfect from '../../content/pl/lessons/english-present-perfect.json' with { type: 'json' };
import plEnglishPresentSimple from '../../content/pl/lessons/english-present-simple.json' with { type: 'json' };
import plEnglishWorkOffice from '../../content/pl/lessons/english-work-office.json' with { type: 'json' };
import plPlaywrightAssertions from '../../content/pl/lessons/playwright-assertions.json' with { type: 'json' };
import plPlaywrightAutoWaiting from '../../content/pl/lessons/playwright-auto-waiting.json' with { type: 'json' };
import plPlaywrightDebugging from '../../content/pl/lessons/playwright-debugging.json' with { type: 'json' };
import plPlaywrightLocatorStrategy from '../../content/pl/lessons/playwright-locator-strategy.json' with { type: 'json' };
import plPlaywrightNetworkMocking from '../../content/pl/lessons/playwright-network-mocking.json' with { type: 'json' };
import plPlaywrightTestIsolation from '../../content/pl/lessons/playwright-test-isolation.json' with { type: 'json' };
import plPythonConditions from '../../content/pl/lessons/python-conditions.json' with { type: 'json' };
import plPythonDictionaries from '../../content/pl/lessons/python-dictionaries.json' with { type: 'json' };
import plPythonFunctions from '../../content/pl/lessons/python-functions.json' with { type: 'json' };
import plPythonListsTuples from '../../content/pl/lessons/python-lists-tuples.json' with { type: 'json' };
import plPythonLoops from '../../content/pl/lessons/python-loops.json' with { type: 'json' };
import plPythonVariables from '../../content/pl/lessons/python-variables.json' with { type: 'json' };
import plTypescriptFunctions from '../../content/pl/lessons/typescript-functions.json' with { type: 'json' };
import plTypescriptGenerics from '../../content/pl/lessons/typescript-generics.json' with { type: 'json' };
import plTypescriptInterfaces from '../../content/pl/lessons/typescript-interfaces.json' with { type: 'json' };
import plTypescriptNarrowing from '../../content/pl/lessons/typescript-narrowing.json' with { type: 'json' };
import plTypescriptTypes from '../../content/pl/lessons/typescript-types.json' with { type: 'json' };
import plTypescriptUtilityTypes from '../../content/pl/lessons/typescript-utility-types.json' with { type: 'json' };

/** Name → raw JSON, so validation errors can say which file is at fault. */
const enLessons: Record<string, unknown> = {
  'english-connectors': englishConnectors,
  'english-phrasal-verbs': englishPhrasalVerbs,
  'english-present-continuous': englishPresentContinuous,
  'english-present-perfect': englishPresentPerfect,
  'english-present-simple': englishPresentSimple,
  'english-work-office': englishWorkOffice,
  'playwright-assertions': playwrightAssertions,
  'playwright-auto-waiting': playwrightAutoWaiting,
  'playwright-debugging': playwrightDebugging,
  'playwright-locator-strategy': playwrightLocatorStrategy,
  'playwright-network-mocking': playwrightNetworkMocking,
  'playwright-test-isolation': playwrightTestIsolation,
  'python-conditions': pythonConditions,
  'python-dictionaries': pythonDictionaries,
  'python-functions': pythonFunctions,
  'python-lists-tuples': pythonListsTuples,
  'python-loops': pythonLoops,
  'python-variables': pythonVariables,
  'typescript-functions': typescriptFunctions,
  'typescript-generics': typescriptGenerics,
  'typescript-interfaces': typescriptInterfaces,
  'typescript-narrowing': typescriptNarrowing,
  'typescript-types': typescriptTypes,
  'typescript-utility-types': typescriptUtilityTypes,
};

export const rawContent: RawContent = {
  subjects,
  modules,
  lessons: enLessons,
  translations: {
  pl: {
    catalog: plCatalog,
    lessons: {
    'english-connectors': plEnglishConnectors,
    'english-phrasal-verbs': plEnglishPhrasalVerbs,
    'english-present-continuous': plEnglishPresentContinuous,
    'english-present-perfect': plEnglishPresentPerfect,
    'english-present-simple': plEnglishPresentSimple,
    'english-work-office': plEnglishWorkOffice,
    'playwright-assertions': plPlaywrightAssertions,
    'playwright-auto-waiting': plPlaywrightAutoWaiting,
    'playwright-debugging': plPlaywrightDebugging,
    'playwright-locator-strategy': plPlaywrightLocatorStrategy,
    'playwright-network-mocking': plPlaywrightNetworkMocking,
    'playwright-test-isolation': plPlaywrightTestIsolation,
    'python-conditions': plPythonConditions,
    'python-dictionaries': plPythonDictionaries,
    'python-functions': plPythonFunctions,
    'python-lists-tuples': plPythonListsTuples,
    'python-loops': plPythonLoops,
    'python-variables': plPythonVariables,
    'typescript-functions': plTypescriptFunctions,
    'typescript-generics': plTypescriptGenerics,
    'typescript-interfaces': plTypescriptInterfaces,
    'typescript-narrowing': plTypescriptNarrowing,
    'typescript-types': plTypescriptTypes,
    'typescript-utility-types': plTypescriptUtilityTypes,
    } as Record<string, unknown>,
  },
  },
};

/** Kept for the content validator, which checks every file on disk is registered. */
export const rawLessons = enLessons;
